import React from "react";

export default function Gap({ height, width }) {
  return <div style={{ height: height, width: width }} />;
}
